import { Popover, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { Fragment } from 'react';

import { Button as EditorButton } from '~components/generic/editor/Button/Button';
import { Hint } from '~components/generic/editor/Hint/Hint';
import ModulesList from '~components/generic/module/ModulesList/ModulesList';
import { PlusIcon } from '~components/icons';
import styles from './ModulesListPopover.css';

type ModulesListPopoverProps = {
  disabled?: boolean;
  index: number;
  parentContext: string;
  type: string;
};

export function ModulesListPopover({ disabled = false, index, parentContext, type }: ModulesListPopoverProps) {
  return (
    <Popover className={clsx(styles.popover, 'modules-list-popover', 'relative inline-flex')}>
      {({ open, close }) => (
        <>
          <div className={clsx(styles.createModule)}>
            <hr className={styles.moduleLine} />
            <Popover.Button as={EditorButton} preIcon={<PlusIcon />} disabled={disabled || open} />
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 -translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150 delay-200"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 -translate-y-1"
          >
            <Popover.Panel as={Hint} className={clsx(styles.panel, 'absolute z-50 transform left-0')}>
              <ModulesList onChooseItem={() => close()} type={type} parentContext={parentContext} index={index} />
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
